import { render, staticRenderFns } from "./StatementAvatar.vue?vue&type=template&id=38501110&scoped=true"
import script from "./StatementAvatar.vue?vue&type=script&lang=ts"
export * from "./StatementAvatar.vue?vue&type=script&lang=ts"
import style0 from "./StatementAvatar.vue?vue&type=style&index=0&id=38501110&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38501110",
  null
  
)

export default component.exports